module.exports = __webpack_public_path__ + "static/media/cypress.74b0052a.svg";